// Faceted gemstone, drawn in SVG so it shimmers in day and night. `cut` picks the silhouette; the business logo sits in the table facet.
const SHAPES = {
  cushion: "M20 4 Q36 4 36 20 Q36 36 20 36 Q4 36 4 20 Q4 4 20 4 Z",
  hexagon: "M20 3 L35 11.5 L35 28.5 L20 37 L5 28.5 L5 11.5 Z",
  pear: "M20 3 C28 12 36 18 36 26 A16 16 0 0 1 4 26 C4 18 12 12 20 3 Z",
  oval: "M20 3 C31 3 36 12 36 20 C36 28 31 37 20 37 C9 37 4 28 4 20 C4 12 9 3 20 3 Z",
  emerald: "M11 4 L29 4 L36 11 L36 29 L29 36 L11 36 L4 29 L4 11 Z",
  freeform: "M14 4 L30 6 L36 18 L31 33 L16 37 L5 27 L6 12 Z",
  trillion: "M20 4 L36 32 Q20 40 4 32 Z",
  baguette: "M8 6 L32 6 L34 34 L6 34 Z",
  round: "M20 4 A16 16 0 1 1 19.9 4 Z",
  cabochon: "M20 6 A14 14 0 1 1 19.9 6 Z",
};

export const GemSvg = ({ cut = "oval", color = "#9B1B30", logo, size = 44, gold = false, className = "", title }) => {
  const d = SHAPES[cut] || SHAPES.oval;
  const id = `g${cut}${color.replace("#", "")}${gold ? "x" : ""}`;
  return (
    <svg viewBox="0 0 40 40" width={size} height={size} className={className} role="img" aria-label={title || "gem"}>
      <defs>
        <linearGradient id={`${id}-f`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#fff" stopOpacity=".85" />
          <stop offset=".35" stopColor={gold ? "#F5D06F" : color} stopOpacity=".9" />
          <stop offset="1" stopColor={gold ? "#8A6A1C" : color} />
        </linearGradient>
        <clipPath id={`${id}-c`}><path d={d} /></clipPath>
      </defs>
      <path d={d} fill={`url(#${id}-f)`} stroke={gold ? "#B8860B" : "rgba(255,255,255,.7)"} strokeWidth="1.2" />
      {/* facet lines */}
      <path d="M20 4 L12 20 L20 36 M20 4 L28 20 L20 36 M4 20 L36 20" stroke="rgba(255,255,255,.45)" strokeWidth=".8" fill="none" clipPath={`url(#${id}-c)`} />
      {logo && <image href={logo} x="10" y="10" width="20" height="20" preserveAspectRatio="xMidYMid slice" clipPath={`url(#${id}-c)`} style={{ borderRadius: 999 }} />}
      {logo && <circle cx="20" cy="20" r="10" fill="none" stroke="rgba(255,255,255,.8)" strokeWidth="1" />}
      <path d="M8 10 L14 6" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" opacity=".9" />
    </svg>
  );
};
